module.exports = __webpack_public_path__ + "static/img/wechart.d2646ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/wechart.jpg
// module id = kE9a
// module chunks = 1